import ApiRequest from '../request/ApiRequest'

export default class CompanySubscriptions {
  constructor() {
    this.ApiRequest = new ApiRequest()
  }

  async get(data) {
    try {
      const res = await this.ApiRequest.get('company_subscriptions', data)
      return res
    } catch (error) {
      return error.response
    }
  }

  async getCompanySubscriptions(data) {
    try {
      const res = await this.ApiRequest.get('get_company_subscriptions', data)
      return res
    } catch (error) {
      return error.response
    }
  }

  async activateFreePlan(data) {
    try {
      const res = await this.ApiRequest.post('activate-free-plan', data)
      return res
    } catch (error) {
      return error.response
    }
  }

  async listWithFilter(data) {
    try {
      const res = await this.ApiRequest.get(
        'company_subscriptions.jsonld',
        data,
        'jsonld'
      )
      return res
    } catch (error) {
      return error.response
    }
  }
}
